import React, { Fragment, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { centsToDollar } from '../../utils/formatters';
import FundingRequestsTable from './FundingRequestsTable';
import NewFundingRequest from './NewFundingRequest';
import { LoanTypeMetricBreakdown } from '../../components';

const styles = makeStyles((theme) => ({
    root: {
      },
      summaryContainer: {
        paddingLeft: '50px',
        paddingRight: '50px',
        width: '85vw'
      },
      summaryHeader: {
          textAlign: 'center'
      },
      summaryTotals: {
        paddingTop: '10px',
        paddingBottom: '10px'
      },
      summaryBody: {
        paddingTop: '10px',
        paddingBottom: '10px'
      },
      summary: {
        backgroundColor: theme.palette.grey.main,
        borderRadius: '5px',
        border: 'groove',
        borderColor: 'black',
        borderWidth: '0.5px',
      },
      table: {
          marginTop: '30px',
          width: '85vw',
          marginRight: '5vw'
      },
      totalList: {
          marginLeft: '10px',
          marginTop: '4px',
          marginBottom: '4px'
      },
      totalChildList: {
        display: 'flex',
        justifyContent: 'space-between'
      },
      totalValue: {
        textAlign: 'right',
        minWidth: '80px'
      },
      totalHeader: {
        paddingRight: '10px'
      },
      totalSectionHeader: {
        textAlign: 'right',
        minWidth: '110px',
        display: 'inline-block'
      }
}));

const FundingRequests = ({ dailyProcessingData, selectedDate }) => {
    const classes = styles();
    useTheme();

    const [showNewFundingRequest, setShowNewFundingRequest] = useState(false);
    const {fundingRequestSummary, fundingRequests} = dailyProcessingData || {};

    const toggleShowNewFundingRequest = () => setShowNewFundingRequest(!showNewFundingRequest);

    return dailyProcessingData === null ? (
        <h1>Loading...</h1>
      ) : (
        <Fragment>
            <Grid container direction="column">
                <Grid item className={classes.summaryContainer}>
                    <h3 className={classes.summaryHeader}>Summary</h3>
                    <Grid container direction="column" className={classes.summary} >
                        <Grid item >
                            <Grid container spacing={2} justifyContent="space-evenly" direction="row" className={classes.summaryBody} >
                                <Grid item className={classes.summaryTotals}>
                                    <span className={classes.totalSectionHeader}>
                                        <b className={classes.totalHeader}>Total Requested Funding:</b>
                                        <span style={{minWidth: '126px', display: 'inline-block'}}>{centsToDollar((Number(fundingRequestSummary.totalFundingAmount) || 0) + (Number(fundingRequestSummary.heldFundingAmount) || 0))}</span>
                                    </span>
                                    <ul className={classes.totalList}>
                                        <li className={classes.totalChildList}>
                                            <span>Non-Held:</span>
                                            <span className={classes.totalValue}>{centsToDollar((fundingRequestSummary.totalFundingAmount || 0))}</span>
                                        </li>
                                        <li className={classes.totalChildList}>
                                            <span>Held:</span>
                                            <span className={classes.totalValue}>{centsToDollar(fundingRequestSummary.heldFundingAmount || 0)}</span>
                                        </li>
                                    </ul>
                                    <span className={classes.totalSectionHeader}>
                                        <b className={classes.totalHeader}>Total Number of Requests:</b>
                                        <span style={{minWidth: '120px', display: 'inline-block'}}>{(fundingRequestSummary.totalFundingNumber || 0) + (fundingRequestSummary.heldFundingNumber || 0)}</span>
                                    </span>

                                    <ul className={classes.totalList}>
                                        <li className={classes.totalChildList}>
                                            <span>Non-Held:</span> {fundingRequestSummary.totalFundingNumber || 0}
                                        </li>
                                        <li className={classes.totalChildList}>
                                            <span>Held:</span> {fundingRequestSummary.heldFundingNumber || 0}
                                        </li>
                                    </ul>
                                    <span className={classes.totalSectionHeader}>
                                        <b className={classes.totalHeader}>Avg Requested Funds:</b>
                                        <span style={{minWidth: '147px', display: 'inline-block'}}>{centsToDollar(fundingRequestSummary.totalFundingAmount && fundingRequestSummary.totalFundingNumber ? fundingRequestSummary.totalFundingAmount / fundingRequestSummary.totalFundingNumber : 0)}</span>
                                    </span>
                                </Grid>
                                <Grid item className={classes.summaryTotals}>
                                    <LoanTypeMetricBreakdown loanType={'Solar'} totalStat={fundingRequestSummary.totalFundingAmountESG || 0} countStat={fundingRequestSummary.totalFundingNumberESG || 0 } additionalMetrics={{
                                        avgAge: fundingRequestSummary.avgAgeESG || 0,
                                        avgCreditScore: fundingRequestSummary.avgCreditScoreESG || 0,
                                        avgTerm: fundingRequestSummary.avgTermESG || 0}}>
                                    </LoanTypeMetricBreakdown>
                                </Grid>

                                <Grid item className={classes.summaryTotals}>
                                    <LoanTypeMetricBreakdown loanType={'Home Improvement'} totalStat={fundingRequestSummary.totalFundingAmountHi || 0} countStat={fundingRequestSummary.totalFundingNumberHi || 0} additionalMetrics={{
                                        avgAge: fundingRequestSummary.avgAgeHi || 0,
                                        avgCreditScore: fundingRequestSummary.avgCreditScoreHi || 0,
                                        avgTerm: fundingRequestSummary.avgTermHi || 0}}>
                                    </LoanTypeMetricBreakdown>
                                </Grid>
                                <Grid item className={classes.summaryTotals}>
                                    <LoanTypeMetricBreakdown loanType={'Healthcare'} totalStat={fundingRequestSummary.totalFundingAmountHc || 0} countStat={fundingRequestSummary.totalFundingNumberHc || 0} additionalMetrics={{
                                        avgAge: fundingRequestSummary.avgAgeHc || 0,
                                        avgCreditScore: fundingRequestSummary.avgCreditScoreHc || 0,
                                        avgTerm: fundingRequestSummary.avgTermHc || 0}}>
                                </LoanTypeMetricBreakdown>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Divider />
                        <Grid item>
                            <Grid container spacing={2} justifyContent="space-evenly" direction="row" className={classes.summaryBody} >
                                {fundingRequestSummary.fundingRequestsSummaryByLender ? fundingRequestSummary.fundingRequestsSummaryByLender.map((row) => (
                                    <Grid item key={row.id}>
                                        <p><b><u>{row.shortName}</u></b></p>
                                        <li>Total Requested Funding: {row.totalFundingAmount ? centsToDollar(row.totalFundingAmount) : "$0"}</li>
                                        <li>Funding Request Count: {row.totalFundingNumber || 0}</li>
                                    </Grid>
                                )) : null}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item className={classes.table}>
                    <FundingRequestsTable fundingRequests={fundingRequests} toggleShowNewFundingRequest={toggleShowNewFundingRequest} selectedDate={selectedDate} />
                </Grid>
            </Grid>
            <NewFundingRequest showNewFundingRequest={showNewFundingRequest} toggleShowNewFundingRequest={toggleShowNewFundingRequest} selectedDate={selectedDate} />
        </Fragment>
    );
}

export default FundingRequests;